import { render } from "./EmployeeAttendanceRecords.vue?vue&type=template&id=533d8d2e&scoped=true"
import script from "./EmployeeAttendanceRecords.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendanceRecords.vue?vue&type=script&lang=js"

import "./EmployeeAttendanceRecords.vue?vue&type=style&index=0&id=533d8d2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533d8d2e"]])

export default __exports__